import { PayloadAction } from 'typesafe-actions';
import { clone } from 'ramda';
import { ClientSideWizardActionTypes, ClientSideWizardState } from './types';

const ClientSideWizardReducer = (
  state: ClientSideWizardState,
  action: PayloadAction<ClientSideWizardActionTypes, any>,
): ClientSideWizardState => {
  let nextState = {} as ClientSideWizardState;
  let stepsKeys = [] as string[];
  let foundIndex = 0;
  switch (action.type) {
    case ClientSideWizardActionTypes.SetClientSideWizardState:
      nextState = { ...state, ...clone(action.payload) };
      return {
        ...nextState,
      };
    case ClientSideWizardActionTypes.Init:
      nextState = {
        ...state,
        formData: {
          previousStep: null,
          data: action.payload.data,
          currentStep: action.payload.currentStep,
          preloadDataAdapter: action.payload.preloadDataAdapter,
          validationOptions: action.payload.validationOptions,
        },
        currentProcessState: {
          stepId: action.payload.stepId,
          completedSteps: action.payload.completedSteps,
          currentStepConfig: state.stepsConfig[action.payload.stepId],
          formData: {
            previousStep: null,
            data: action.payload.data,
            currentStep: action.payload.currentStep,
            preloadDataAdapter: action.payload.preloadDataAdapter,
            validationOptions: action.payload.validationOptions,
          },
        },
        initialized: true,
        totalSteps: action.payload.totalSteps,
        completedSteps: action.payload.completedSteps,
      };
      return {
        ...nextState,
      };
    case ClientSideWizardActionTypes.GoToNextStep:
      stepsKeys = Object.keys(state.stepsConfig);
      foundIndex = stepsKeys.indexOf(state.currentProcessState.stepId!);
      return {
        ...state,
        currentProcessState: {
          formData: state.formData,
          stepId: stepsKeys[foundIndex + 1],
          completedSteps: state.currentProcessState.completedSteps + 1,
          currentStepConfig: state.stepsConfig[stepsKeys[foundIndex + 1] as string],
        },
        formData: {
          ...state.formData,
          previousStep: stepsKeys[foundIndex],
          currentStep: stepsKeys[foundIndex + 1],
        },
        completedSteps: state.currentProcessState.completedSteps + 1,
      };
    case ClientSideWizardActionTypes.GoToPreviousStep:
      stepsKeys = Object.keys(state.stepsConfig);
      foundIndex = stepsKeys.indexOf(state.currentProcessState.stepId!);
      return {
        ...state,
        currentProcessState: {
          formData: state.formData,
          stepId: stepsKeys[foundIndex - 1],
          completedSteps: state.currentProcessState.completedSteps - 1,
          currentStepConfig: state.stepsConfig[stepsKeys[foundIndex - 1] as string],
        },
        formData: {
          ...state.formData,
          previousStep: stepsKeys[foundIndex],
          currentStep: stepsKeys[foundIndex - 1],
        },
        completedSteps: state.currentProcessState.completedSteps - 1,
      };
    case ClientSideWizardActionTypes.SetNavigationAction:
      return {
        ...state,
        goToNextWizardStep: action.payload.goToNextWizardStep,
        goToPreviousWizardStep: action.payload.goToPreviousWizardStep,
      };
    case ClientSideWizardActionTypes.SetStepsConfig:
      return {
        ...state,
        stepsConfig: action.payload,
      };
    case ClientSideWizardActionTypes.SetNetworkCallErrors:
      return {
        ...state,
        errorState: clone(action.payload),
      };
    default: {
      return state;
    }
  }
};

export { ClientSideWizardReducer };
